import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"
import acusacionOptions from "../../common/acusacionOptions"

const AdminEstructuraComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()

  return (<>

    <CRUD
      id="estructuras"

      isModal={false}
      cssClass="modalRight"
      recordButtonsPosition="start"
      filterOpen={true}
      showModal={props.show}
      toggleCRUD={props.toggle}
      title={t("Estructuras Delictivas/Casos") ?? ""}
      icon={"fas fa-users"}
      getRecordsPath={`estructura/list`}
      getRecordsMethod="post"
      addEditRecordPath={`estructura/addEdit?currentUserId=${user.ID}`}
      deleteRecordPath="estructura/delete"
      filterFields={[
        {
          name: "search",
          htmlType: "text",
          dbType: "string",
          title: t("Nombre") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },

      ]}
      fieldsList={[
        {
          name: "fotoCaso",
          title: t("Foto"),
          htmlType: "image",
        },
        {
          name: "nombre",
          title: t("Nombre"),
        },
        {
          name: "enlace3",
          title: t("Enlace 3"),
          htmlType: "link"
        },
        {
          name: "enlace4",
          title: t("Enlace 4"),
          htmlType: "link"
        },
        {
          name: "enlace5",
          title: t("Enlace 5"),
          htmlType: "link"
        },


      ]}
      fields={[

        { name: "id", htmlType: "hidden", dbType: "string" },
        { name: "nombre", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6", required: true },

        {
          name: "acusacion", htmlType: "selectMultiple", dbType: "array", title: t("Acusación") ?? "", containerClass: "col-12 col-md-6", required: true,
          dataSourceLocal: acusacionOptions,
          dataSourceTextField: "name",
          dataSourceValueField: "id",
        },
        { name: "fotoCaso", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },


        { name: "detalles", htmlType: "textarea", dbType: "string", title: t("Detalles") ?? "", containerClass: "col-12" },
        { name: "separator", dbType: "string", title: t("Fuentes") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "enlace1", htmlType: "text", dbType: "string", title: t("Enlace 1") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace2", htmlType: "text", dbType: "string", title: t("Enlace 2") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace3", htmlType: "text", dbType: "string", title: t("Enlace 3") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace4", htmlType: "text", dbType: "string", title: t("Enlace 4") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace5", htmlType: "text", dbType: "string", title: t("Enlace 5") ?? "", containerClass: "col-12 col-md-6" },

        {
          name: "estructuraMiembros", htmlType: "crud",
          dbType: "string", title: t("PADEP") ?? "", containerClass: "col-12 ",
          getRecordsPath: "estructuraMiembro/list",

          addEditRecordPath: "estructuraMiembro/addEdit",
          deleteRecordPath: "estructuraMiembro/delete",
          dependOf: "estructuraId",
          fieldList: [

            { name: "identificador", required: false, htmlType: "informe", dbType: "string", title: t("Ver Informe") ?? "", containerClass: "col-12 col-md-6" },
            { name: "vinculo", htmlType: "text", dbType: "string", title: t("Vinculo") ?? "", containerClass: "col-12 col-md-6" },
            { name: "identificador", required: true, htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6" },
            { name: "nombres", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6" },
            { name: "primerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
            { name: "segundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
            { name: "alias", htmlType: "text", dbType: "string", title: t("Alias") ?? "", containerClass: "col-12 col-md-6" },
            { name: "foto", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },
            { name: "fotoCedula", htmlType: "picture", dbType: "string", title: t("Foto Cédula") ?? "", containerClass: "col-12 col-md-6" },
          ],
          subItems: [
            { name: "id", htmlType: "hidden", dbType: "string" },
            { name: "identificador", required: true, htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6" },
            { name: "nombres", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6" },
            { name: "primerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
            { name: "segundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
            { name: "alias", htmlType: "text", dbType: "string", title: t("Alias") ?? "", containerClass: "col-12 col-md-6" },
            {
              name: "vinculo", htmlType: "select", dbType: "string", title: t("Vínculo") ?? "", containerClass: "col-12 col-md-6",
              dataSourceLocal: [
                { id: "Lider", name: t("Líder") ?? "" },
                { id: "CoAutor/Cabecilla", name: t("CoAutor/Cabecilla") ?? "" },
                { id: "Complice", name: t("Cómplice") ?? "" },
                { id: "Colaborador", name: t("Colaborador") ?? "" },
              ],
              dataSourceTextField: "name",
              dataSourceValueField: "id",
            },

            { name: "foto", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },
            { name: "fotoCedula", htmlType: "picture", dbType: "string", title: t("Foto Cédula") ?? "", containerClass: "col-12 col-md-6" },

          ]
        },

        {
          name: "estructuraVictimas", htmlType: "crud",
          dbType: "string", title: t("Victimas") ?? "", containerClass: "col-12 ",
          getRecordsPath: "estructuraVictima/list",

          addEditRecordPath: "estructuraVictima/addEdit",
          deleteRecordPath: "estructuraVictima/delete",
          dependOf: "estructuraId",
          fieldList: [

            { name: "identificador", required: false, htmlType: "informe", dbType: "string", title: t("Ver Informe") ?? "", containerClass: "col-12 col-md-6" },
            { name: "vinculo", htmlType: "text", dbType: "string", title: t("Vinculo") ?? "", containerClass: "col-12 col-md-6" },
            { name: "identificador", required: true, htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6" },
            { name: "nombres", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6" },
            { name: "primerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
            { name: "segundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
            { name: "alias", htmlType: "text", dbType: "string", title: t("Alias") ?? "", containerClass: "col-12 col-md-6" },
            { name: "foto", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },
            { name: "fotoCedula", htmlType: "picture", dbType: "string", title: t("Foto Cédula") ?? "", containerClass: "col-12 col-md-6" },
          ],
          subItems: [
            { name: "id", htmlType: "hidden", dbType: "string" },
            { name: "identificador", required: true, htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6" },
            { name: "nombres", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6" },
            { name: "primerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
            { name: "segundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
            { name: "alias", htmlType: "text", dbType: "string", title: t("Alias") ?? "", containerClass: "col-12 col-md-6" },
            // {
            //   name: "vinculo", htmlType: "select", dbType: "string", title: t("Vínculo") ?? "", containerClass: "col-12 col-md-6",
            //   dataSourceLocal: [
            //     { id: "Lider", name: t("Líder") ?? "" },
            //     { id: "CoAutor/Cabecilla", name: t("CoAutor/Cabecilla") ?? "" },
            //     { id: "Complice", name: t("Cómplice") ?? "" },
            //     { id: "Colaborador", name: t("Colaborador") ?? "" },
            //   ],
            //   dataSourceTextField: "name",
            //   dataSourceValueField: "id",
            // },

            { name: "foto", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },
            { name: "fotoCedula", htmlType: "picture", dbType: "string", title: t("Foto Cédula") ?? "", containerClass: "col-12 col-md-6" },

          ]
        },

        {
          name: "estructuraCompania", htmlType: "crud",
          dbType: "string", title: t("Empresas / RASADEP") ?? "", containerClass: "col-12 ",
          getRecordsPath: "estructuraCompania/list",

          addEditRecordPath: "estructuraCompania/addEdit",
          deleteRecordPath: "estructuraCompania/delete",
          dependOf: "estructuraId",
          fieldList: [

            { name: "identificador", required: false, htmlType: "informe", dbType: "string", title: t("Ver Informe") ?? "", containerClass: "col-12 col-md-6" },

            { name: "identificador", required: true, htmlType: "text", dbType: "string", title: t("RNC") ?? "", containerClass: "col-12 col-md-6" },
            { name: "nombre", htmlType: "text", dbType: "string", title: t("Nombre / Razón Social") ?? "", containerClass: "col-12 col-md-6" },

          ],
          subItems: [
            { name: "id", htmlType: "hidden", dbType: "string" },
            { name: "identificador", required: true, htmlType: "searchRNC", dbType: "string", title: t("RNC") ?? "", containerClass: "col-12 col-md-6" },
            {
              name: "nombre", htmlType: "search", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6",
              dataSourceTextField: "name",
              dataSourceValueField: "id",
              dataSource: "dgii/list",
              datasourceMethod: "GET",
            },
            { name: "detalles", htmlType: "textarea", dbType: "string", title: t("Detalles") ?? "", containerClass: "col-12 col-md-6" },

          ]
        },

      ]}
    />
  </>
  )
}

export default AdminEstructuraComponent
